<template>
  <div class="login">
    <div class="center_box t-10">
      <div class="login_tit l-h70">
        找回密码
      </div>
      <div class="login_min mt0">
        <form id="loginForm">
          <div>
            <p>新密码</p>
            <input class="pass_word" id="user_name" v-model="params.newPassword" @blur="checkComplete" type="text" name="username" placeholder="" value="">
          </div>
          <div style="position: relative;">
            <p>再次输入新密码</p>
            <input class="pass_word" id="" v-model="params.againPassword" @blur="checkComplete" type="text"  placeholder="" value="">
            <p class="errInfo t80 show" id="errInfo">{{errorMsg}}</p>
          </div>
          <div>
            <button :class="{can_login:disabled==true}" id="login" type="" :disabled="!disabled">完成</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'forgetPasswordStep1',
    data () {
      return {
        disabled:false,
        errorMsg:'',
        params:{
          newPassword:'',
          againPassword:''
        }
      }
    },
    methods:{
      checkComplete:function(){
        var passReg = /^\d{6}$/;
        if(passReg.test(this.params.newPassword) && passReg.test(this.params.againPassword) && this.params.newPassword == this.params.againPassword){
          this.disabled=true;
          this.errorMsg = '';
        }else{
          this.disabled=false;
          if(!passReg.test(this.params.newPassword) || !passReg.test(this.params.againPassword)){
            this.errorMsg = '请输入6位数字密码';
            return false;
          }else{
            this.errorMsg = '两次输入的密码不一致';
            return false;
          }

        }
      }
    }
  }
</script>
<style lang="less">
  .l-h70{
    line-height: 70px;
  }
  .login_min{
  div{
    margin-top: 10px;
  p{
    line-height: 40px;
    font-size: 16px;
  }
  }
  }
  .t80{
    top:80px!important;
  }
  .t-10{
    top: 10%!important;
    margin-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/forget_password/step2.vue